export default __webpack_public_path__ + "static/media/icon.9a7ff548.png";